import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import {
  CandidatesConfig,
  CandidatesPrivileges,
} from '@modules/candidates/candidates.abstract.config';

@Component({
  selector: 'mojo-candidate-badges',
  templateUrl: './candidate-badges.component.html',
  styleUrls: ['./candidate-badges.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateBadgesComponent {
  @Input() favorite: boolean;
  @Input() silver: boolean;
  @Input() alumni: boolean;
  @Input() warning: boolean;
  @Input() inline = false;
  privileges: CandidatesPrivileges;

  constructor(private candidatesConfig: CandidatesConfig) {
    this.privileges = this.candidatesConfig.privileges;
  }
}
